import { render, staticRenderFns } from "./Yiyang.vue?vue&type=template&id=47ee3dff&scoped=true"
import script from "./Yiyang.vue?vue&type=script&lang=js"
export * from "./Yiyang.vue?vue&type=script&lang=js"
import style0 from "./Yiyang.vue?vue&type=style&index=0&id=47ee3dff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ee3dff",
  null
  
)

export default component.exports